var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateDashboard',{attrs:{"client-is-required":true,"route":_vm.$listRoutes.dashboardPerformances,"filters-route":_vm.$listRoutes.dashboardPerformancesFilters,"title":_vm.$t('menu.performances')}})
}
var staticRenderFns = []

export { render, staticRenderFns }